import React from "react";
import { Container, PageHeader } from "@/components/common";

export default function Privacy() {
  return (
    <div>
      <PageHeader eyebrow="Your data" title="Privacy notice" subtitle="How Lawley Village Line Dance Club looks after your information." />
      <Container className="py-10">
        <div className="prose max-w-2xl space-y-4 text-[#5C4A42]">
          <p>We only collect the information we need to run the club: your name, email address and (optionally) a phone number, along with the classes you choose to follow and the dances you save.</p>
          <p><strong className="text-[#2D1E18]">What we do with it.</strong> Your details are used to manage your membership account and to send you information relevant to your classes. Registering for an account is not treated as consent to marketing — you can set your communication preferences in your account at any time.</p>
          <p><strong className="text-[#2D1E18]">Keeping it private.</strong> Your saved dances, followed classes and profile are private to you. Other members cannot see them. Only club administrators can access personal data, and only where needed to run the club.</p>
          <p><strong className="text-[#2D1E18]">Your rights.</strong> You can edit your details, change your preferences, or delete your account at any time from your account page. Passwords are securely encrypted and never stored as plain text.</p>
          <p>This notice reflects our commitment to UK GDPR principles including data minimisation and secure handling of personal information.</p>
        </div>
      </Container>
    </div>
  );
}
